import React, { ReactNode } from 'react';
import { Theme } from '@mui/material';

import { Typography } from './Typography';

export type StatusChipVariant = 'default' | 'disabled' | 'success' | 'warning' | 'info' | 'error';

export type StatusChipProps = {
  label: string | ReactNode;
  variant?: StatusChipVariant;
  className?: string;
};

export type StatusChipGroupProps = {
  chips: StatusChipProps[];
};

type GetStylesProps = {
  theme: Theme;
  variant: StatusChipVariant;
};

const getStyles = (props: GetStylesProps) => {
  const { theme, variant } = props;

  const defaultStyles = {
    py: 0.5,
    px: 1,
    borderRadius: '4px',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.default.light,
    cursor: 'default',
    whiteSpace: 'nowrap',
  };

  if (variant === 'default') {
    return defaultStyles;
  }

  if (variant === 'disabled') {
    return {
      ...defaultStyles,
      color: theme.palette.text.disabled,
    };
  }

  return {
    ...defaultStyles,
    color: theme.palette[variant].main,
    backgroundColor: theme.palette[variant].light,
  };
};

export const StatusChip: React.FC<StatusChipProps> = (props) => {
  const { label, variant = 'default' } = props;

  return (
    <Typography sx={(theme) => getStyles({ theme, variant })} variant='subtitle2' component='span'>
      {label}
    </Typography>
  );
};
